import { Icon56ErrorOutline } from '@vkontakte/icons';
import { classNames, Text } from '@vkontakte/vkui';
import React, { type ReactElement, memo, useCallback, useEffect } from 'react';
import { Button, ButtonSizeMode } from 'reactApp/ui/Button/Button';
import { MobileDialog } from 'reactApp/ui/Mobile/MobileDialog/MobileDialog';

import styles from './PreOverquotaModal.css';
import type { PreOverquotaModalProps } from './PreOverquotaModal.types';
import { useContent, useTitle } from './useContent';

export const PreOverquotaModalMobile = memo(function PreOverquotaModalMobile({
    primaryButtonText = 'Снять ограничения',
    secondaryButtonText,
    onShow,
    onDismiss,
    onClick,
    onSecondaryClick,
    onClose,
}: PreOverquotaModalProps): ReactElement | null {
    useEffect(() => {
        onShow?.();
    }, [onShow]);

    const onPrimaryHandler = useCallback(() => {
        onClick?.();
        onClose?.();
    }, []);

    const onSecondaryHandler = useCallback(() => {
        onSecondaryClick?.();
        onClose?.();
    }, []);

    const onCloseHandler = useCallback(() => {
        onDismiss?.();
        onClose?.();
    }, [onDismiss]);

    return (
        <MobileDialog
            id="overquota-alert-clear-mobile"
            onClose={onCloseHandler}
            topmost
            mod="base"
            isRebrandingQuotaLanding
            closeMode="darkAndRound"
        >
            <div className={classNames(styles.rootMobile)}>
                <div className={styles.imageWrapper}>{<Icon56ErrorOutline className={styles.imageIcon} />}</div>
                <Text className={styles.title}>{useTitle()}</Text>
                <Text className={styles.text}>{useContent()}</Text>
                <div className={styles.footerWrapper}>
                    <Button theme="vk" primary onClick={onPrimaryHandler} sizeMode={ButtonSizeMode.big}>
                        {primaryButtonText}
                    </Button>
                    {!!secondaryButtonText && (
                        <Button theme="vk" onClick={onSecondaryHandler} sizeMode={ButtonSizeMode.big}>
                            {secondaryButtonText}
                        </Button>
                    )}
                </div>
            </div>
        </MobileDialog>
    );
});

PreOverquotaModalMobile.displayName = 'PreOverquotaModalMobile';
